import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../../../core/consts";
import {COMPETITOR_PLAYER_STATS} from "../competitor-players-stats-module.consts";
import {CompetitorPlayersStatsModuleState} from "../models/competitor-players-stats-module.state";
import {CompetitorPlayersStatsModuleController} from "../competitor-players-stats-module.controller";

export class CompetitorPlayersStatsModuleTabChangeEventHandler extends ActionHandler {
  type: ACTION_TYPES;
  state: CompetitorPlayersStatsModuleState;
  controller: CompetitorPlayersStatsModuleController;

  static injectables = [...ActionHandler.injectables];

  constructor() {
    super();

    this.type = COMPETITOR_PLAYER_STATS.ACTION_TYPES.tabChange;
  }

  action(params) {
    this.state.activeTabIndex = params.tab.index;

    if(this.state.isShallowShotMap){
      this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.onShotSelected, {
        shot: this.state.selectedPlayer.selectedShotKey === null ? this.state.selectedPlayer.shots?.first(): this.state.selectedPlayer.selectedShotKey
      });
    }

    this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.tabClick, {
      athleteId: this.state.selectedPlayer.athleteId,
      gameId: this.state.game.id,
      status: this.state.game.statusGroup,
      clickType: params.tab.analyticName
    })
  }
}


